// src/api/comments.js
// Functions to interact with the comments API

/**
 * Fetch comments for a render
 * @param {string} renderId Render ID
 * @returns {Promise<Array>} Array of comment objects
 */
export const fetchComments = async (renderId) => {
  try {
    const response = await fetch(`/api/renders/${renderId}/comments`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error fetching comments for render ${renderId}:`, error);
    throw error;
  }
};

/**
 * Post a new comment on a render
 * @param {string} renderId Render ID
 * @param {Object} commentData Comment data (name, email, text)
 * @returns {Promise<Object>} Newly created comment object
 */
export const postComment = async (renderId, commentData) => {
  try {
    const response = await fetch(`/api/renders/${renderId}/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commentData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error posting comment for render ${renderId}:`, error);
    throw error;
  }
};